<script setup lang="ts">
const emit = defineEmits(["remove"])
const { onSearch } = useInstantMenu()
const query = defineModel<string>("query")
const input = useTemplateRef("input")

const quitAndRemove = () => {
  emit("remove")
}

const quitAndSearch = () => {
  onSearch()
}

onMounted(async () => {
  await nextTick()
  input.value?.focus()
})
</script>

<template>
  <div class="theme-picker-container">
    <div class="theme-picker-description">
      Theme is
    </div>
    <div class="theme-picker-outer">
      <input
        ref="input"
        v-model="query"
        type="text"
        class="theme-picker-input"
        placeholder="Describe the theme.."
        @keydown.enter.stop.prevent="quitAndSearch()"
        @keydown.esc.stop.prevent="emit('remove')"
      >
    </div>
    <div class="theme-picker-close" @click="quitAndRemove()">
      <icon-action type="cross" size="2xs" />
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.theme-picker-container
  @apply flex flex-none items-center gap-[#{$menu-search-gap-item-facet}] relative
  @apply h-[24px]
  @apply rounded-[#{$menu-br-item}] overflow-hidden
  @apply t-menu-sm

.theme-picker-description
  @apply flex flex-none items-center
  @apply h-full px-1.5

.theme-picker-close
  @apply flex flex-none items-center
  @apply h-full px-1

.theme-picker-description
  @apply bg-$global-purple-accent
  @apply text-$global-purple-primary

.theme-picker-close
  @apply bg-$global-purple-accent
  @apply text-$global-purple-primary
  @apply cursor-pointer
  &:hover
    @apply bg-$global-purple-secondary

.theme-picker-outer
  @apply flex-none flex items-center gap-[#{$menu-search-gap-item-facet-section}]
  @apply h-full pl-1
  @apply bg-$global-purple-accent
  @apply text-$global-purple-primary
  @apply cursor-pointer
  @apply max-w-[2500px] // This seems to be required due to some css reasons I can't figure out

.theme-picker-input
  @apply w-full
  @apply bg-transparent focus:outline-none
  @apply text-$global-t-default
  &::placeholder
    @apply text-$global-purple-secondary

.theme-picker-file-icon
  @apply text-$global-purple-primary

.theme-picker-selection
  @apply w-full

.theme-picker-select-container
  @apply mt-2

.theme-picker-option-wrapper
  &.selected, &:hover
    @apply bg-[#{$menu-bg-item-hover}] -m-1 p-1 rounded-[#{$menu-br-item}]
</style>
